import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useCdnImg } from '../composables';
import type { Format } from '../types';
import { validateSize } from '../utils';

interface Props {
  src: string;
  width?: number | string;
  height?: number | string;
  format?: Format;
  loading?: 'lazy' | 'eager';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CdnImg',
  props: {
    src: null,
    width: null,
    height: null,
    format: null,
    loading: null
  },
  setup(__props: any) {

const props = __props as {
  src: string;
  width?: number | string;
  height?: number | string;
  format?: Format;
  loading?: 'lazy' | 'eager';
};



const { generateUrl } = useCdnImg();

const width = computed(() => validateSize(props.width));
const height = computed(() => validateSize(props.height));

const imageSrc = computed(() => generateUrl(props.src, {
  width: width.value,
  height: height.value,
  format: props.format,
}));

return { __sfc: true,props, generateUrl, width, height, imageSrc }
}

})